import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterViewAll from '../VeltCommentsSidebarFilterViewAll/VeltCommentsSidebarFilterViewAll';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterDocument = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-document-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterDocument.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterDocument.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterDocument.ViewAll = VeltCommentsSidebarFilterViewAll;
VeltCommentsSidebarFilterDocument.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterDocument;
